import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';

/**
 * این کامپوننت برای اینپوت های مبلغی ریال است
 */
export default function InputPricing({
  name,
  clear,
  label,
  disabled,
  handelValue,
  defaultValue,
}) {
  const [value, setValue] = useState('');

  const hedelonCheng = (event) => {
    if (event?.target?.value) {
      const vlaue = parseInt(event.target.value.replace(/,/g, ''));
      setValue(vlaue);
      handelValue(name, vlaue);
    } else {
      setValue('');
      handelValue(name, '');
    }
  };

  useEffect(() => {
    if (clear) {
      hedelonCheng('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clear]);

  return (
    <Form.Group>
      {label && (
        <Form.Label>
          {label} <small>(ريال)</small>
        </Form.Label>
      )}
      <br />

      <NumberFormat
        dir='ltr'
        value={value}
        disabled={disabled}
        autoComplete={'off'}
        decimalSeparator={'-'}
        onChange={hedelonCheng}
        thousandSeparator={','}
        name={name ? name : ''}
        defaultValue={defaultValue ? defaultValue : ''}
        style={{ height: '50px', width: '100%', border: 'none !important' }}
      />
    </Form.Group>
  );
}
InputPricing.propTypes = {
  /**لیبل اینپوت است */
  label: PropTypes.string,
  /**برای ارسال مقدار اولیه برای اینپوت است */
  defaultValue: PropTypes.string,
  /** مقدار هلدر اینپوت است */
  Placeholder: PropTypes.string,
  /** نام اینپوت است */
  name: PropTypes.string,
  /** ارسال مقدار اینپوت به بالا است */
  handelValue: PropTypes.func,
};
